import { Injectable, inject, Signal } from '@angular/core';
import { NavigationItem } from '@lyceo/homi-dashboard/shared/util-models';
import { Store } from '@ngrx/store';
import { UserActions } from './user.actions';
import * as UserSelectors from './user.selectors';

@Injectable({
  providedIn: 'root',
})
export class UserFacade {
  private readonly store: Store = inject(Store);

  public userMenuItems: Signal<NavigationItem[]> = this.store.selectSignal(
    UserSelectors.selectNavigationItems,
  );
  public showWalkthrough: Signal<boolean> = this.store.selectSignal(
    UserSelectors.selectShowWalkthrough,
  );

  public walkthroughClicked(): void {
    this.store.dispatch(UserActions.walkthroughClicked());
  }
}
